const config = {
    id: 8,
    name: "倒计时",
    type: 1,
    module_code: "countdown",
    icon: "icon-tms-countdown",
    font_icon: "&#xe648;",
    style_type: 1,
    link_type: 0,
    property_data: {
        time_type: 0,
        text_color: "#fff",
        background_color: "#ff6000",
        time_color: "#333",
        time_text: "距离活动开始"
    }
};
export default config;